import React, { Component, createRef } from 'react';
import { Box, type Theme } from '@mui/material';

//import classnames from 'classnames';
import {pink,green,grey, purple} from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionActions from '@mui/material/AccordionActions';
//import AccordionSummary from '@mui/material/AccordionSummary';
//import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
//import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {ClosableBar, LoadDialog,} from '../../components/dialogs';
import {Download,} from '../../ajax';
//import { PDFIcon, CSVIcon, JSONIcon, ZIPIcon} from '../../components/icons';
import { CSVIcon, ZIPIcon} from '../../components/icons';
import { clone, errorMessage } from '../../core';
import { formatDate } from '../../components/renderers';
import { create, isValid } from '../../components/form';
import { extendedstyles } from '../appstyles';
import { bizupload } from '../../ajax/bizrequest';

const s:any ={
  root: {
    width: '100%',
  },
  titlebar: {
    padding:0,
    backgroundColor: 'success.light',
  },
  summary: {
    alignItems: 'space-between'
  },
  heading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
  }),
  secondaryHeading: (theme:Theme)=> ({
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  }),
  topheading: {
    fontWeight:'bold',
  },
  close: {
    flexBasis: '33.33%',
    align:'right'
  },
  details: {
    alignItems: 'center',
    p: 1,

  },
  column: {
    flexBasis: '33.33%',
  },
  iconsroot: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  pdficon: {
    m: 2,
    color: pink["500"]
  },
  csvicon: {
    m: 2,
    color: purple["500"]
  },
  jsonicon: {
    m: 2,
    color: green["800"]
  },
  zipicon: {
    m: 2,
    color: grey["500"]
  },
  customicon: {
    m: 2,
    color: pink["500"]
  },
  iconHover: {
    m: 2,
    '&:hover': {
      color: green[200],
    },
  },
};

class UploadForm extends Component<any,any> {
  form = createRef();
  constructor(props:any) {
    super(props);
    this.state = {
      conf: {},
      views:[],
      count:0,
      open: true,
      valid: false,
      loading: false,
      loadcolor: 'inherit',
      params:{s:props.service,a:'upload'},
      data: {},
      datasets: null,
      dataset: null
    };
  }

  formconfig = () => {
    const cbip = {InputLabelProps:{ shrink:true,}};
    const config = {
      service: {
        name: 'dataform',
        title: 'Generate Upload',
        eform: [
          { id:'rpt',label:'Upload Type',type:'fa',req:1,ops:{placeholder:'Select Type',strval:true,...cbip},cp:{t:'lcs',s:'uploadtype'}},
          { id:'fmt',label:'Upload Format',type:'fa',req:1,ops:{placeholder:'Select Format',strval:true,...cbip},cp:{t:'lcs',s:'format'}},
          { id:'sdt',label:'Start Date',type:'df',req:1,ops:{ placeholder:'Select Start Date'} },
          { id:'edt',label:'Stop Date',type:'df',req:1,ops:{ placeholder:'Select Stop Date'} }
        ],
      },
      create: true,
      actions: { add: 'Print' },
      panels: { add: 'simple' },
    };
    return config;
  }

  setValid = (data:any) => {
    const {config:conf} = this.props;
    const config = conf||this.formconfig();
    const valid = isValid(config,data);
    //this.props.setValid(valid);
    this.setState({valid});
  }

  onChange = (name:any) => (value:any) => {
    //console.log('form.onChange:',name, value);
    const {data} = this.state;
    const newdata = {...data,[name]:value};
    this.setValid(newdata);
    this.setState({data:newdata});
    //this.setState((state:any) => ({params: {...state.params,[name]:value}}));
  }

  makeform = (conf:any) => {
    const config = conf||this.formconfig();
    //console.log('makeform.config:',config);
  
    const { record, classes, extras } = this.props;
    const sconfig = clone(config);
    //const sdata = sconfig.service;
    const {service:sdata,type} = sconfig;
    const mode = 'add';
    const formatters = { dob: formatDate };
    const onChange = this.onChange.bind(this);
    const form = create(mode,sdata,record,formatters,onChange,classes,{...(extras||{}),ref:this.form});
    //const form = this.columnlayout(formitems,classes);
    const title = sdata.title;
    return {title,form,type};
  }

  startLoading = () => {
    this.setState({loading:true});
  }

  stopLoading = () => {
    this.setState({loading:false});
  }

  onClick = (type:any) => async(event:any) => {
    try{
      //var btn = event.target;
      //console.log('upload type:',type);
      const {config,service:name,action,record} = this.props;
      const {service:svc} = config||{};
      const {name:sname} = svc||{};
      const {params:sparams,data: extra} = this.state;
      //console.log('print action:',name,sparams,action,record,sname);
      const params = {...sparams,...extra,s:sname,a:'upload'};
      //console.log('send upload:',type,params,name,extra,record);
      this.startLoading();
      await bizupload(type,params,name,extra,record);
    }
    catch(err){
      console.log('upload.handle.failed',err);
      const errormessage = errorMessage(err);
      this.props.showNotification(errormessage);
    }
    finally{
      console.log('leaving');
      this.stopLoading();
    }
  } 

  onExpChange = (event:any,expanded:boolean) => {
    if (!expanded) this.setState({open:false})
  }

  onClose = (event:any) => {
    this.setState({open:false})
  }

  render() {
    const {config,classes } = this.props;
    const {title,form,type} = this.makeform(config);
    const {open,valid,loading,loadcolor} = this.state;
    const offmode = !valid||loading;
    //const cncmode = 
    return (
      <Dialog open={open}>
        <DialogTitle id="window-dialog-title" sx={{...s.titlebar}} >
          <ClosableBar onClose={this.onClose}>{title}</ClosableBar>
        </DialogTitle>
        <DialogContent sx={{...s.dialogcontent}}>
      <Box sx={{...s.root}}>
        
        <Accordion defaultExpanded onChange={this.onExpChange}>
          <AccordionDetails sx={{...s.details}}>
            <Box sx={{...s.root}}>
            <LoadDialog open={loading} onClick={this.onClose} value={"wait!"} color={loadcolor} />
            {/* <Box> */}
                {form}
              {/* </Box> */}
              
            </Box>
          </AccordionDetails>
          <Divider />
        <AccordionActions>
        {/* <Box sx={{...s.iconsroot}}> */}
           <Button variant="contained" color="secondary" startIcon={<CSVIcon titleAccess="Cancel Upload"/>} sx={{...s.csvicon}} disabled={!loading} onClick={this.stopLoading}>
            Cancel
          </Button>
          <Button variant="contained" color="primary" startIcon={<ZIPIcon titleAccess="LCD File Upload"/>} sx={{...s.zipicon}} disabled={offmode} onClick={this.onClick(type)}>
            Submit
          </Button>
         {/* <Button variant="contained" color="success" startIcon={<JSONIcon titleAccess="JSON Download" />} sx={{...s.jsonicon}} disabled={!valid} onClick={this.onClick('json')}>
            JSON
          </Button>
          <Button variant="contained" color="warning" startIcon={<ZIPIcon titleAccess="ZIP Download" />} sx={{...s.zipicon}} disabled={!valid} onClick={this.onClick('zip')}>
            ZIP
          </Button> */}
      {/* </Box> */}
        </AccordionActions>
        </Accordion>
      </Box>
      </DialogContent>
      </Dialog>
    );
  }

  handleClick = (name:any) => () => {
    //var btn = event.target;
    var {data,record} = this.props;
    var d = new Download();
    d.downloadFile(name,data,record);
  } 

  // renderDownload() {
  //   const {classes } = this.props;
  //   return (
  //     <Box sx={{...s.root}}>
        
  //       <Accordion>
  //         <AccordionSummary expandIcon={<ExpandMoreIcon />}>
  //           <Typography className={classnames(classes.heading,classes.topheading)}>
  //             Downloads
  //           </Typography>
  //         </AccordionSummary>
  //         <AccordionDetails sx={{...s.details}}>
  //           <Box>
  //             <Box sx={{...s.iconsroot}}>
  //                 <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('pdf')}>
  //           <PDFIcon titleAccess="PDF Download"/>
  //         </Button>
  //                 <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('csv')}>
  //           <CSVIcon titleAccess="CSV Download"/>
  //         </Button>
  //                 <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('json')}>
  //           <JSONIcon titleAccess="JSON Download" />
  //         </Button>
  //                 <Button variant="contained" sx={{...s.customicon}} onClick={this.handleClick('zip')}>
  //           <ZIPIcon titleAccess="ZIP Download" />
  //         </Button>
  //             </Box>
  //           </Box>
  //           <Box></Box>
  //         </AccordionDetails>
  //       </Accordion>
  //     </Box>
  //   );
  // }
}

export default UploadForm;
